import React from 'react';
import styled from 'styled-components';
import {Button} from '../../../../atoms/Buttons/Button';

export const BasicControl: React.FC<
  React.PropsWithChildren & {onClick: () => void}
> = ({children, onClick}) => (
  <StyledCircleButton
    onClick={onClick}
    aria-label={undefined}
    variant="glassy"
    round={true}
  >
    {children}
  </StyledCircleButton>
);

const StyledCircleButton = styled(Button)`
  &&& {
    width: 32px;
    height: 32px;
    flex-basis: 32px;
    border-color: transparent;
    box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.08);
    padding: 0;
  }
`;
